export default class TheBestOffer
{
    constructor(
        companyId,
        companyAddress,
        companyName,
        deliveryDistance,
        deliveryPrice,
        grainId,
        hasContract,
        lastCallDate,
        marginalProfit,
        purchasePrice,
        estimatedPrice,
        withOrWithoutVAT
    ) {
        this.companyId = companyId;
        this.companyAddress = companyAddress;
        this.companyName = companyName;
        this.deliveryDistance = deliveryDistance;
        this.deliveryPrice = deliveryPrice;
        this.grainId = grainId;
        this.hasContract = hasContract;
        this.lastCallDate = lastCallDate;
        this.marginalProfit = marginalProfit;
        this.purchasePrice = purchasePrice;
        this.estimatedPrice = estimatedPrice;
        this.withOrWithoutVAT = withOrWithoutVAT;
        this.estimatedPriceLabel = this.estimatedPrice + (this.withOrWithoutVAT === null ? "" : this.withOrWithoutVAT ? " С НДС" : " Без НДС");
        this.hasContractLabel = this.hasContract ? "Да" : "Нет";
        this.deliveryDistanceLabel = this.deliveryDistance + " км";
        this.deliveryPriceLabel = this.deliveryPrice + " р/т";
    }
}



// WEBPACK FOOTER //
// ./entities/TheBestOffer.js